"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getHideIfEmpty;

var _get2 = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getHideIfEmpty(_ref) {
  var node = _ref.node,
      isEditor = _ref.isEditor,
      readOnly = _ref.readOnly;
  var displayIfEmpty = (0, _get2.default)(node, ['display', 'displayIfEmpty'], false); // if the value is `readOnly` (i.e. readOnly from sync) then it doesn't matter if they're an
  // editor or not and we should `hideIfEmpty`

  if (readOnly) {
    return true;
  } // if `displayIfEmpty` then show the element


  if (displayIfEmpty) {
    return false;
  } // if the person is an editor then we shouldn't hide this value when empty because they'll never
  // know that they can edit it


  if (isEditor) {
    return false;
  } // otherwise hide it


  return true;
}